import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CnIcon } from '@alife/cn-ui';
import { useCnOneSearch, pluginPropsKeyPrefix } from './plugins/use-cn-one-search';
import AsyncSwitch from './components/sync-dictionary/async-switch';
const { ActionSetter } = window.VisualEngineUtils || {};
const getLowCodePlugin = () => {
    return {
        name: 'CnFilterPro',
        plugin: [
            {
                // 插件英文名
                name: 'OneSearchPlugin',
                // 插件中文名
                title: 'CnFilter-OneSearch插件',
                // 插件源码扩展
                method: useCnOneSearch,
                // 插件低码扩展
                lowCodeConfig: {
                    getPrototypeList: () => {
                        return [
                            ...[
                                {
                                    name: 'useOneSearch',
                                    // type: 'field',
                                    title: {
                                        label: (_jsxs("div", { children: ["\u5F00\u542FOneSearch (", _jsx("a", { target: '_blank', href: 'https://alidocs.dingtalk.com/i/nodes/ydxXB52LJqPvwoK0IjdGjXQlVqjMp697?utm_scene=team_space', children: "\u63A5\u5165\u6587\u6863" }), ")"] })),
                                    },
                                    display: 'inline',
                                    setter: _jsx(AsyncSwitch, {})
                                },
                                {
                                    name: 'bizAccessKey',
                                    // type: 'field',
                                    title: {
                                        label: 'OneSearch应用ID',
                                    },
                                    tip: {
                                        content: '算法平台提供的bizAccessKey，可在算法平台的OneSearch应用列表中获取',
                                    },
                                    display: 'inline',
                                    isRequired: true,
                                    setter: 'StringSetter',
                                    supportVariable: true
                                },
                                {
                                    name: 'operatorId',
                                    title: {
                                        label: (_jsxs("div", { children: ["\u7CFB\u7EDF\u767B\u5F55ID\u53D8\u91CF", _jsx(CnIcon, { type: 'icon-help' })] })),
                                    },
                                    display: 'inline',
                                    setter: 'StringSetter',
                                    supportVariable: true,
                                    tip: {
                                        content: '业务系统用户登录的ID变量，一般会在全局变量中可以获取，例如：window.userInfo?.id',
                                    },
                                    defaultValue: {
                                        "type": "JSExpression",
                                        "value": "window._GATEWAY_PF && window._GATEWAY_PF.osBucNo",
                                    }
                                },
                            ].map((item) => {
                                return {
                                    ...item,
                                    name: `${pluginPropsKeyPrefix}${item.name}`,
                                    condition(props) {
                                        return (item.name === 'useOneSearch' ||
                                            props?.parent?.getPropValue?.(`${pluginPropsKeyPrefix}useOneSearch`) === true);
                                    },
                                };
                            }),
                            {
                                name: 'senior',
                                type: 'group',
                                title: '高级配置',
                                tab: 'OneSearch',
                                collapsed: true,
                                display: 'accordion',
                                items: [
                                    {
                                        name: 'useDefaultTransformFields',
                                        title: {
                                            label: (_jsxs("div", { children: ["\u5F00\u542F\u524D\u7AEF\u8C03\u7528\u7B97\u6CD5", _jsx(CnIcon, { type: 'icon-help' })] })),
                                        },
                                        display: 'inline',
                                        setter: 'BoolSetter',
                                        tip: {
                                            content: '由前端调用算法的suggest 和 languageTranslator接口，通过onSearch方法回调把转换好的查询字段给业务前端。如果开启后登录人ID为必填',
                                        },
                                        defaultValue: true
                                    },
                                    {
                                        name: 'presetHabitSetting',
                                        title: '预设查询条件',
                                        display: 'inline',
                                        setter: 'JsonSetter',
                                        supportVariable: true,
                                    },
                                    {
                                        name: 'fetchSuggestApiConfig',
                                        title: '请求搜索建议API配置',
                                        display: 'inline',
                                        setter: {
                                            componentName: 'ServiceChoiceSetter',
                                            props: {
                                                params: {
                                                    env: 'pre',
                                                    pageSize: 999,
                                                },
                                            },
                                        },
                                    },
                                    {
                                        name: 'customShowLimitNum',
                                        title: '输入框Tag上限',
                                        display: 'inline',
                                        setter: 'NumberSetter',
                                        supportVariable: true,
                                        tip: {
                                            content: '搜索Tag展示数量，超过数量的搜索条件将会被收起，点击展开按钮可查看全部搜索条件',
                                        },
                                    },
                                    {
                                        name: 'translateResults',
                                        display: 'inline',
                                        setter: 'StringSetter',
                                        supportVariable: true,
                                        title: {
                                            label: (_jsxs("div", { children: ["\u67E5\u8BE2\u7ED3\u679C\u53D8\u91CF\u7ED1\u5B9A", _jsx(CnIcon, { type: 'icon-help' })] })),
                                        },
                                        tip: {
                                            content: '如果服务端调用算法的languageTranslator接口，需要将算法转换的数据放在data.extra属性中，绑定state.CnTable?.__tableExtra__变量',
                                        },
                                    },
                                    {
                                        name: 'versionSwitchChange',
                                        title: '切换传统版回调',
                                        display: 'inline',
                                        setter: 'FunctionSetter',
                                        supportVariable: true,
                                        tip: {
                                            content: '切换传统版事件回调方法',
                                        },
                                    },
                                    {
                                        name: 'onSearchFormat',
                                        title: '格式化查询参数方法',
                                        display: 'inline',
                                        tip: {
                                            content: '该方法会对onSearch方法的参数进行转换，适用于低码场景。参数参考SearchParams类型',
                                        },
                                        setter: (_jsx(ActionSetter, { supportTypes: ['page'], defaultCode: `/**
                          * onOneSearchFormat
                          * @params
                          */
                          function onOneSearchFormat(params) {
                            return {
                              ...params,
                            };
                          }`, defaultActionName: 'onOneSearchFormat' })),
                                    },
                                    {
                                        name: 'isHiddenViewSelector',
                                        title: '隐藏我的查询条件',
                                        display: 'inline',
                                        setter: 'BoolSetter',
                                        supportVariable: true,
                                    },
                                    {
                                        name: 'isHiddenHelpDoc',
                                        title: '隐藏帮助文档',
                                        display: 'inline',
                                        setter: 'BoolSetter',
                                        supportVariable: true,
                                    },
                                ].map((item) => {
                                    return {
                                        ...item,
                                        name: `${pluginPropsKeyPrefix}${item.name}`,
                                        condition(props) {
                                            return (item.name === 'useOneSearch' ||
                                                props?.parent?.getPropValue?.(`${pluginPropsKeyPrefix}useOneSearch`) === true);
                                        },
                                    };
                                }),
                            },
                        ];
                    },
                },
            },
        ],
    };
};
window.CN_UI_PLUGIN = window.CN_UI_PLUGIN || [];
window.CN_UI_PLUGIN.push(getLowCodePlugin());
